import React from 'react';
import { ratioToPercent, round2Display } from '../../lib/format';

import PlayerStatsTableHeader from './PlayerStatsTableHeader';
import PlayerStatsTable from './PlayerStatsTable';
import PlayerStatsHeader from './PlayerStatsHeader';

const tableTitles = [
  'EFG',
  'ORR',
  'FTR',
  'TOV',
  'FG%',
  'FG3%',
  'FG2%',
  'FT%',
  'FG3 PAR',
  'PPS',
  'TS',
  'USG',
  'AST%',
  'ATO',
];

const PlayerRatesStats = ({ stats, onPlayerSort }) => {
  if (!stats) return '';
  return (
    <PlayerStatsTable>
      <PlayerStatsTableHeader titles={tableTitles} />
      <TableBody players={stats.team.players} />
    </PlayerStatsTable>
  );
};

export default PlayerRatesStats;

const TableBody = ({ players }) => (
  <tbody className="striped">
    {players.map(player => (
      <TableStatRow key={`${player.player.id}`} player={player} />
    ))}
  </tbody>
);

const TableStatRow = ({ player }) => {
  return (
    <tr>
      <PlayerStatsHeader player={player.player} />
      <td>{ratioToPercent(player.calculated.efg)}</td>
      <td>{ratioToPercent(player.calculated.orr)}</td>
      <td>{ratioToPercent(player.calculated.ftr)}</td>
      <td>{ratioToPercent(player.calculated.tov)}</td>
      <td>{ratioToPercent(player.calculated.fg_perc)}</td>
      <td>{ratioToPercent(player.calculated.fg3_perc)}</td>
      <td>{ratioToPercent(player.calculated.fg2_perc)}</td>
      <td>{ratioToPercent(player.calculated.ft_perc)}</td>
      <td>{ratioToPercent(player.calculated.fg3_par)}</td>
      <td>{round2Display(player.calculated.pps)}</td>
      <td>{ratioToPercent(player.calculated.true_shooting)}</td>
      <td>{ratioToPercent(player.calculated.usage)}</td>
      <td>{ratioToPercent(player.calculated.assist_percentage)}</td>
      <td>{round2Display(player.calculated.ato)}</td>
    </tr>
  );
};
